import React from "react";

export function Panel({ children, className = "", as = "div", ...rest }) {
  const Tag = as;
  return (
    <Tag className={`panel ${className}`} {...rest}>
      {children}
    </Tag>
  );
}

export function Eyebrow({ children, className = "" }) {
  return <div className={`eyebrow ${className}`}>{children}</div>;
}

export function MonoLabel({ children, className = "", ...rest }) {
  return <div className={`mono-label ${className}`} {...rest}>{children}</div>;
}

export function LiveDot({ color = "green", label = "LIVE" }) {
  const dotClass = color === "red" ? "live-dot red" : "live-dot";
  const textColor = color === "red" ? "var(--red)" : "var(--green)";
  return (
    <span className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase" style={{ color: textColor }}>
      <span className={dotClass} />
      {label}
    </span>
  );
}

export function KPI({ label, value, hint, accent = "text" }) {
  const color = accent === "red" ? "var(--red-2)" : accent === "green" ? "var(--green)" : "var(--text)";
  return (
    <Panel className="p-5">
      <div className="mono-label">{label}</div>
      <div className="mt-3 font-serif text-3xl sm:text-4xl" style={{ color }}>{value}</div>
      {hint && <div className="mt-2 text-xs" style={{ color: "var(--taupe)" }}>{hint}</div>}
    </Panel>
  );
}
